/**
 * Scrolls to a specific element within a scrollable container
 *
 * @param elementId - The ID of the element to scroll to
 * @param scrollableContainerRef - Reference to the scrollable container
 */
export const scrollToElement = (
  elementId: string,
  scrollableContainerRef: React.RefObject<HTMLDivElement>,
) => {
  const element = document.getElementById(elementId)
  if (element && scrollableContainerRef.current) {
    const container = scrollableContainerRef.current
    const elementRect = element.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()

    // Calculate element's position relative to the document
    const elementOffsetTop =
      elementRect.top + container.scrollTop - containerRect.top

    // Scroll to position the element at the top
    container.scrollTo({
      top: elementOffsetTop,
      behavior: "smooth",
    })
  }
}
